import React from 'react'

import { Grid, Typography } from '@material-ui/core'

import moment from 'moment'

const FormularioStatus = (props) => {
    const {nome, dataInicio, dataLimite} = props

    return (
        <>
            <Grid>
                <Typography style={{ fontWeight: "bolder" }}>
                    Formulário vinculado nesta reunião:
                </Typography>
                <Typography>
                {nome ? (
                    `${nome}`
                ) : (
                    <>Nenhum até o momento</>
                )}
                </Typography>
            </Grid>
            <br />
            {dataInicio && (
                <Grid>
                <Typography style={{ fontWeight: "bolder" }}>
                    Este formulário está disponibilizado no período:
                </Typography>
                <Typography>
                    {moment(dataInicio, "YYYY-MM-DDTHH:mm:ss").format(
                    "DD/MM/YYYY"
                    )}{" "}
                    até{" "}
                    {moment(dataLimite, "YYYY-MM-DDTHH:mm:ss").format(
                    "DD/MM/YYYY"
                    )}
                </Typography>
                </Grid>
            )}
        </>
    )
}

export default FormularioStatus